import { PayloadAction } from "@reduxjs/toolkit";
import { call, put, takeLatest, take } from "redux-saga/effects";

import {
  impersonateUser,
  impersonateUserSuccess,
  impersonateUserFailure,
  impersonationComplete,
  stopImpersonation,
  stopImpersonationSuccess,
  stopImpersonationComplete,
} from "./slice";
import { fetchSelectedBrandIdSuccess } from "../brands/slice";
import { applySagaError } from "../utils/saga";
import { resetImpersonationState } from "../actions";
import { ImpersonateUserPayload } from "./types";
import { rpcApi } from "@/api/rpc.api";
import { User } from "@/types/auth";

export function* impersonateUserSaga(action: PayloadAction<ImpersonateUserPayload>) {
  try {
    const { email } = action.payload;

    const data: User = yield call(rpcApi.getUserByEmail, email);

    yield put(resetImpersonationState());
    yield put(impersonateUserSuccess(data)); 
    yield take(fetchSelectedBrandIdSuccess.type);
    yield put(impersonationComplete());
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "superuser.impersonateUser",
      failureAction: impersonateUserFailure,
    });
  }
}

export function* stopImpersonationSaga() {
  try {
    yield put(resetImpersonationState());
    yield put(stopImpersonationSuccess());
    yield take(fetchSelectedBrandIdSuccess.type);
    yield put(stopImpersonationComplete());
  } catch (error) {
    yield* applySagaError(error, {
      operationName: "superuser.stopImpersonation",
    });
  }
}

export function* superuserSaga() {
  yield takeLatest(impersonateUser.type, impersonateUserSaga);
  yield takeLatest(stopImpersonation.type, stopImpersonationSaga);
}
